import { render, staticRenderFns } from "./VerifiedEnrollee.vue?vue&type=template&id=722b606b&"
import script from "./VerifiedEnrollee.vue?vue&type=script&lang=js&"
export * from "./VerifiedEnrollee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports